import React from 'react';

/**
  Usage:
  <ConditionalWrapper
    condition={shouldLinkToHome}
    wrapper={children => <a href="/">{children}</a>}
  >
    <img src="logo.png"/>
  </ConditionalWrapper>
 */
type Props = {
  children: React.ReactNode;
  condition: boolean;
  wrapper: (children: React.ReactNode) => JSX.Element;
};
export function ConditionalWrapper({ condition, wrapper, children }: Props) {
  return condition ? wrapper(children) : <>{children}</>;
}
